import { render, staticRenderFns } from "./ClinicFeature.vue?vue&type=template&id=2fb691ec&"
import script from "./ClinicFeature.vue?vue&type=script&lang=js&"
export * from "./ClinicFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports